import * as React from 'react';
import { clsx } from 'clsx';
import { UIHeading4, UIText2 } from '@cian/ui-kit';

import { ESalesType, ISalesLink } from '../../../../types/offersData';

import * as styles from './SalesLink.css';

interface ISalesLinkProps {
  link: ISalesLink;
  onClick(link: ISalesLink): void;
}

const SALES_TYPE_CLASSES = new Map<ESalesType, string>([
  [ESalesType.PromoIndexPage, styles['newbuilding-promo']],
  [ESalesType.SalesLeader, styles['sales-leader']],
  [ESalesType.SalesStart, styles['sales-start']],
  [ESalesType.UpcomingSale, styles['sales-soon']],
  [ESalesType.ConsultantPage, styles['consultant']],
]);

export function SalesLink({ link, onClick }: ISalesLinkProps) {
  const handleClick = React.useCallback(() => {
    onClick(link);
  }, [onClick, link]);

  return (
    <a className={clsx(styles['link'], SALES_TYPE_CLASSES.get(link.salesType))} href={link.url} onClick={handleClick}>
      <div className={styles['content']}>
        <UIHeading4 as="h4">{link.title}</UIHeading4>
        <UIText2 color="gray60_100">{link.text}</UIText2>
      </div>
    </a>
  );
}
